<div class="row mt-3">
  <div class="col-4">

  </div>

  <div class="col-4"></div>
  <div class="col-4">
    <div class="d-flex align-items-center justify-content-end">
      <button class="btn btn-clear ms-2">
        <i class=" fa-light fa-bell fa-2xl text-primary"></i>
      </button>
      <a href="">
        <div class="img">
          <img src="profile.png" class="img-fluid rounded-circle" alt="" srcset="">
        </div>
      </a>
    </div>
  </div>
</div>
<div class="mt-3">
  <div class="d-flex justify-content-between align-items-center py-3">
    <a [routerLink]="['/home']"><i class="fa fa-light fa-arrow-left fa-xl"></i></a>
  </div>
</div>

<div class="my-3">
  <h3>Return Item</h3>
</div>

<div class="form-group">
  <label for="" class="form-label">Barcode Number</label>
  <input type="text" class="form-control" placeholder="Barcode Number">
</div>
<div class="form-group">
  <label for="" class="form-label">Reason for Returning Item</label>
  <select name="" id="" class="form-select" placeholder="Select reason for retuning item">
    <option value="">Select reason for retuning item</option>
    <option value="">Damaged Item</option>
    <option value="">Expired Item</option>
  </select>
</div>


<div class="bottom">
  <div class="row">
    <div class="col-6 offset-3 text-center">
      <button class="btn btn-primary btn-block" (click)="continue()">Continue </button>
    </div>
  </div>
</div>
